"use client";
import { useState, useEffect, useContext } from "react";
import { Heart } from "lucide-react";
import { FaHeart } from "react-icons/fa";
import { WishlistContext } from "@/context/WishlistContext";
import { Badge } from "@/components/ui/badge";

const AddWishlist = ({ data }) => {
  const { wishlist, toggleWishlist } = useContext(WishlistContext);
  const [wishlistProducts, setWishlistProducts] = useState([]);

  useEffect(() => {
    setWishlistProducts(wishlist);
  }, [wishlist]);

  const isInWishlist = wishlistProducts.some((item) => item?._id === data?._id);

  return (
    <>
      {isInWishlist ? (
        <Badge variant="outline" onClick={() => toggleWishlist(data)} className="cursor-pointer">
          <FaHeart size={15} className="text-custom-red" />
        </Badge>
      ) : (
        <Badge
          variant="outline"
          onClick={() => toggleWishlist(data)}
          className="flex items-center gap-2 cursor-pointer"
        >
          <Heart
            size={15}
            className="text-custom-black "
          />
          Add to wishlist
        </Badge>
      )}
    </>
  );
};

export default AddWishlist;
